"use client";
import React from "react";
import Image from "next/image";
import { Box, Center, Grid, GridItem, HStack, Stack } from "@chakra-ui/react";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import CheckImg from "public/cloudUnifiedCom/Check_circle.png";
import { APPS_CONSTANTS } from "./constants";

const AppsComponent = () => {
  const { heading, description, list, image } = APPS_CONSTANTS;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();
  return (
    <Grid
      id="apps-comp"
      gap={{ base: 4, lg: 16 }}
      templateColumns={{
        base: "repeat(1, 1fr)",
        md: "repeat(5, 1fr)",
      }}
    >
      <GridItem colSpan={{ base: 1, md: 2 }}>
        <Center height={"full"}>
          <Box
            h={{ base: "300px", sm: "440px" }}
            w={{ base: "100%", sm: "80%", md: "430px" }}
            position="relative"
            alignSelf={"center"}
          >
            <Image
              src={image}
              alt="IntroImg"
              fill
              style={{ objectFit: "contain", objectPosition: "center" }}
              placeholder="blur"
              loading="lazy"
              sizes="100vw"
            />
          </Box>
        </Center>
      </GridItem>
      <GridItem colSpan={{ base: 1, md: 3 }} maxW={{ base: "100%", xl: "80%" }}>
        <Center height={"full"}>
          <Stack gap={6}>
            <Heading as="h2" variant={HeadingVariant}>
              {heading}
            </Heading>
            <Text variant={TextVariant} color="text.100">
              {description}
            </Text>
            <Stack gap={{ base: 2, md: 3 }}>
              {list.map((point, index) => (
                <HStack key={index} align="start">
                  <Image
                    alt={"Point"}
                    src={CheckImg}
                    style={{ height: "auto", width: "20px", paddingTop: "4px" }}
                  />{" "}
                  <Text variant={TextVariant}>{point}</Text>
                </HStack>
              ))}
            </Stack>
          </Stack>
        </Center>
      </GridItem>
    </Grid>
  );
};

export default AppsComponent;
